import React from "react";
import LegalPageLayout from "../components/LegalPageLayout";
export default function PrivacyPolicy() {
  return <LegalPageLayout tKey="privacy" />;
}
